

















































import { Component, Vue } from "vue-property-decorator";
import SelfieSvg from "@/components/svg/SelfieSvg.vue";
import PrepareForSelfie from "@/modules/selfie/components/PrepareForSelfieSvg.vue";
import PrepareForSelfieDesktopSvg from "@/modules/selfie/components/PrepareForSelfieDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { isSafari } from "@/utils/index";
import nextTick from "vue";
import axios from "axios";

@Component({
  metaInfo() {
    return {
      title: "Orba One | Prepare For your Selfie",
    };
  },
  components: {
    "selfie-svg": SelfieSvg,
    "prepare-for-selfie": PrepareForSelfie,
    "prepare-for-selfie-desktop": PrepareForSelfieDesktopSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class PrepareSelfie extends Vue {
  get isSafariBrowser() {
    return isSafari();
  }

  mounted() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.playPrepareForSelfie();
    }
  }

  beforeUnmount() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopPrepareForSelfie();
    }
  }
  async onTakeSelfie() {
    await new nextTick();
    this.clickTakeSelfie();
    if (this.isSafariBrowser) {
      this.$router.push({ name: "fallbackSelfie", query: this.$route.query });
    } else {
      this.$router.push({ name: "captureSelfie", query: this.$route.query });
    }
  }

  clickTakeSelfie() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 3;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
